import React from 'react'
import { GroupBase, SingleValueProps } from 'react-select'

import { CountryItem } from 'components/CountryPhoneInput/CountryPhoneInput'
import { BaseOption } from 'shared/types/types'

import Arrow from 'assets/img/shared/arrow2.svg?react'
import s from './CustomSingleValue.module.scss'

export const CustomSingleValue: React.FC<
  SingleValueProps<BaseOption<CountryItem>, false, GroupBase<BaseOption<CountryItem>>>
> = ({ data }) => (
  <div style={{ display: 'flex', alignItems: 'center' }} className={s.wrapper}>
    <img
      src={`/img/flags/${data.value.country}.png`}
      alt={data.value.label}
      style={{ width: '28px', height: '20px', marginRight: '6px' }}
    />
    <Arrow width="15" height="5" style={{ color: '#757575' }} />
  </div>
)
